
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/news",
      function () {
        return require("private-next-pages/blogs/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/news"])
      });
    }
  